<section
  class="bg-white p-4 tablet:p-5 desktop:p-6 rounded-xl overflow-x-hidden"
  [ngClass]="{
    'mb-12 tablet:mb-10 desktop:mb-24': isMarginLarge(),
    'mb-4 tablet:mb-3': !isMarginLarge(),
  }"
>
  <div class="flex flex-col gap-y-4">
    <div class="flex flex-row gap-x-3 desktop:gap-x-0 desktop:justify-center desktop:items-center">
      <div class="flex-1 flex flex-col gap-y-2">
        <h3 class="font-headline text-mobileH3 tablet:text-tabletH3 desktop:text-desktopH3">
          {{ 'components.prolongation.title' | scTranslate | async }}
        </h3>
        <p
          class="text-mobileMd tablet:text-tabletMd desktop:text-desktopMd tablet:tracking-wide desktop:mr-6"
        >
          {{
            (isContractExpired()
              ? 'components.prolongation.descriptionAfterContractEnd'
              : 'components.prolongation.description'
            )
              | scTranslate
                : { substitution: Substitutions.Date, subValue: contractEndDate() | scDate }
              | async
          }}
        </p>
        <div class="hidden tablet:flex desktop:hidden mt-3">
          <sc-button
            variant="secondary"
            [relativeUrl]="`/${AppRouting.Products}/${AppRouting.Prolongation}`"
            class="w-fit max-w-max h-[43px]"
          >
            <span class="tracking-wide px-5 text-tabletMd font-semibold">
              {{ 'components.prolongation.checkDealsButton' | scTranslate | async }}
            </span>
          </sc-button>
        </div>
      </div>
      <div class="hidden desktop:flex z-10">
        <sc-button
          variant="secondary"
          [relativeUrl]="`/${AppRouting.Products}/${AppRouting.Prolongation}`"
          class="w-fit max-w-max h-[43px]"
        >
          <span class="tracking-wide px-5 desktop:px-6 text-tabletMd font-semibold">
            {{ 'components.prolongation.checkDealsButton' | scTranslate | async }}
          </span>
        </sc-button>
      </div>
      <div
        class="w-[90px] tablet:w-[185px] h-[76px] tablet:h-[147px] desktop:h-[156px] tablet:-mr-9 desktop:-my-6 desktop:-ml-9 shrink-0 self-center"
      >
        <sc-svg name="update" class="w-full h-full"></sc-svg>
      </div>
    </div>
    <div class="block tablet:hidden self-center">
      <sc-button
        variant="secondary"
        class="w-fit max-w-max h-[41px]"
        [relativeUrl]="`/${AppRouting.Products}/${AppRouting.Prolongation}`"
      >
        <span class="tracking-wide px-4 text-mobileMd font-semibold">
          {{ 'components.prolongation.checkDealsButton' | scTranslate | async }}</span
        >
      </sc-button>
    </div>
  </div>
</section>
